module.exports = __webpack_public_path__ + "img/tbt23-1-1999_.prt.7a7e942d.jpg";